import Dashboard from "components/Dashboard";
import NavBar from "components/NavBar";
import { YourGeneratedPodcastProvider } from "context/LibraryYourGeneratedPodcastContext";
import { QueueViewProvider } from "context/QueueViewContext";
import { SideBarActiveProvider } from "context/SideBarActiveContext";
import { CurrentlyPlayingContextProvider } from "context/CurrentlyPlayingContext";
import { UserInfoContextProvider } from "context/UserInfoContext";
import { RandomTopicContextProvider } from "context/RandomTopicContext";

const HomePage = () => {
  return (
    <>
      <RandomTopicContextProvider>
        <UserInfoContextProvider>
          <SideBarActiveProvider>
            <QueueViewProvider>
              <YourGeneratedPodcastProvider>
                <CurrentlyPlayingContextProvider>
                  <NavBar />
                  <Dashboard />
                </CurrentlyPlayingContextProvider>
              </YourGeneratedPodcastProvider>
            </QueueViewProvider>
          </SideBarActiveProvider>
        </UserInfoContextProvider>
      </RandomTopicContextProvider>
    </>
  );
};

export default HomePage;
